// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket {
  position: sticky;
  height: fit-content;
}
.ticket ion-card-header {
  border-bottom: 1px solid #f2f2f2;
}
.ticket ion-card-header p {
  color: black;
  font-size: 16px;
  font-weight: 400;
  margin-top: 0px !important;
}
.ticket ion-card-header ion-text {
  font-weight: 500;
}
.ticket ion-card-content {
  padding: 0 !important;
}
.ticket .quantity-input {
  padding: 6px;
  background: var(--ion-color-light);
  z-index: 11111;
  position: relative;
  margin: 0;
  width: 30% !important;
  margin-left: auto;
}
.ticket .quantity-input ion-button {
  height: 30px;
  width: 30px;
  min-height: 30px;
  min-width: 30px;
  max-height: 30px;
  max-width: 30px;
  --background: white;
}
.ticket .quantity-input ion-button ion-icon {
  font-size: 20px;
}
.ticket .quantity-input h2 {
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
.ticket .quantity-input ion-input {
  width: 30px !important;
  height: 30px !important;
  min-height: 30px !important;
  max-height: 30px !important;
}
.ticket .quantity-input ion-input input {
  padding: 0;
  font-size: 18px !important;
}

.new-tickets {
  width: 100%;
  column-count: 2;
  gap: 0;
  padding: 0 8px;
  margin-top: -8px;
}
.new-tickets .pin {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
  display: inline-block;
  background: #fff;
  margin: 8px;
}
.new-tickets ion-card-header {
  border-bottom: 1px solid var(--ion-color-dark-light);
  background: var(--ion-color-dark);
  padding: 16px;
}
.new-tickets ion-card-header h1 {
  color: white;
  font-size: 18px;
}
.new-tickets ion-card-header ion-button {
  height: 30px;
  min-height: 30px;
}
.new-tickets ion-card ion-card-content {
  padding: 0 !important;
}

.product {
  --inner-padding-top: 16px;
  --inner-padding-bottom: 16px;
  --inner-padding-end: 16px;
}
.product .space-top {
  margin-top: 6px;
}
.product::part(native) {
  align-items: flex-start;
}
.product .quantity {
  margin-top: 16px;
}
.product .quantity p {
  color: var(--ion-color-primary);
  font-weight: 600;
}
.product ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: var(--ion-color-medium);
}
.product ul li {
  font-size: 14px !important;
  margin-top: 4px;
}
.product ul li p,
.product ul li span,
.product ul li div {
  font-size: 14px !important;
}
.product ion-checkbox {
  margin-top: 16px;
}

ion-card {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/separate-items/separate-items.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;AACJ;AACI;EACI,gCAAA;AACR;AACQ;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AACZ;AAEQ;EACI,gBAAA;AAAZ;AAII;EACI,qBAAA;AAFR;AAKI;EACI,YAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;AAHR;AAKQ;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAHZ;AAKY;EACI,eAAA;AAHhB;AAOQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AALZ;AAQQ;EACI,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AANZ;AAQY;EACI,UAAA;EACA,0BAAA;AANhB;;AAYA;EACI,WAAA;EACA,eAAA;EACA,MAAA;EACA,cAAA;EACA,gBAAA;AATJ;AAWI;EACI,6BAAA;EAAA,qBAAA;EAAA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AATR;AAYI;EACI,oDAAA;EACA,iCAAA;EACA,aAAA;AAVR;AAYQ;EACI,YAAA;EACA,eAAA;AAVZ;AAaQ;EACI,YAAA;EACA,gBAAA;AAXZ;AAgBQ;EACI,qBAAA;AAdZ;;AAoBA;EACI,yBAAA;EACA,4BAAA;EACA,yBAAA;AAjBJ;AAmBI;EACI,eAAA;AAjBR;AAoBI;EACI,uBAAA;AAlBR;AAqBI;EACI,gBAAA;AAnBR;AAqBQ;EACI,+BAAA;EACA,gBAAA;AAnBZ;AAuBI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;AArBR;AAuBQ;EACI,0BAAA;EACA,eAAA;AArBZ;AAuBY;;;EAGI,0BAAA;AArBhB;AA0BI;EACI,gBAAA;AAxBR;;AA4BA;EACI,SAAA;AAzBJ","sourcesContent":[".ticket {\n    position: sticky;\n    height: fit-content;\n\n    ion-card-header {\n        border-bottom: 1px solid #f2f2f2;\n\n        p {\n            color: black;\n            font-size: 16px;\n            font-weight: 400;\n            margin-top: 0px !important;\n        }\n\n        ion-text {\n            font-weight: 500;\n        }\n    }\n\n    ion-card-content {\n        padding: 0 !important;\n    }\n\n    .quantity-input {\n        padding: 6px;\n        background: var(--ion-color-light);\n        z-index: 11111;\n        position: relative;\n        margin: 0;\n        width: 30% !important;\n        margin-left: auto;\n\n        ion-button {\n            height: 30px;\n            width: 30px;\n            min-height: 30px;\n            min-width: 30px;\n            max-height: 30px;\n            max-width: 30px;\n            --background: white;\n\n            ion-icon {\n                font-size: 20px;\n            }\n        }\n\n        h2 {\n            width: 100%;\n            height: 26px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-weight: 600;\n        }\n\n        ion-input {\n            width: 30px !important;\n            height: 30px !important;\n            min-height: 30px !important;\n            max-height: 30px !important;\n\n            input {\n                padding: 0;\n                font-size: 18px !important;\n            }\n        }\n    }\n}\n\n.new-tickets {\n    width: 100%;\n    column-count: 2;\n    gap: 0;\n    padding: 0 8px;\n    margin-top: -8px;\n\n    .pin {\n        width: stretch;\n        display: inline-block;\n        background: #fff;\n        margin: 8px;\n    }\n\n    ion-card-header {\n        border-bottom: 1px solid var(--ion-color-dark-light);\n        background: var(--ion-color-dark);\n        padding: 16px;\n\n        h1 {\n            color: white;\n            font-size: 18px;\n        }\n\n        ion-button {\n            height: 30px;\n            min-height: 30px;\n        }\n    }\n\n    ion-card {\n        ion-card-content {\n            padding: 0 !important;\n        }\n    }\n\n}\n\n.product {\n    --inner-padding-top: 16px;\n    --inner-padding-bottom: 16px;\n    --inner-padding-end: 16px;\n\n    .space-top {\n        margin-top: 6px;\n    }\n\n    &::part(native) {\n        align-items: flex-start;\n    }\n\n    .quantity {\n        margin-top: 16px;\n\n        p {\n            color: var(--ion-color-primary);\n            font-weight: 600;\n        }\n    }\n\n    ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        color: var(--ion-color-medium);\n\n        li {\n            font-size: 14px !important;\n            margin-top: 4px;\n\n            p,\n            span,\n            div {\n                font-size: 14px !important;\n            }\n        }\n    }\n\n    ion-checkbox {\n        margin-top: 16px;\n    }\n}\n\nion-card {\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
